import React from "react";
import { CollectionsViewWrap } from "./CollectionsViewWrap";

const CollectionsReactView = () => {
  return <CollectionsViewWrap />;
};

window.CollectionsReactView = CollectionsReactView;
